/**
 * Themes Registry
 * This file maintains the registry of available themes
 */

import { ThemeConfig } from "./types";
import { skazkaTheme } from "./skazka";
import { defaultTheme } from "./default";

// Theme registry mapping vendor names to theme configs
export const themeRegistry: Record<string, ThemeConfig> = {
  default: defaultTheme,
  skazka: skazkaTheme,
};
